import { meetingBodyLink, meetingLink } from './links.js';
import { meetingBodyTypeValueLabels, meetingStatusValueLabels } from './value-labels.js';
/**
 * Combination data source: Meeting Bodies x Meetings (Compliance).
 * Meeting frequency and open meetings law compliance tracking. Shows whether bodies are
 * meeting on schedule, public notice compliance, and agenda publication status.
 */
export const meetingComplianceCube = {
    category: 'Meetings',
    description: 'Meeting schedule compliance by meeting body including public notice and agenda publication tracking.',
    label: 'Meeting Schedule & Compliance',
    measures: {
        'meeting_compliance.count': { label: 'Count', type: 'number' },
        'meeting_compliance.distinct_meeting_bodies': {
            label: 'Distinct Meeting Bodies',
            type: 'number',
        },
        'meeting_compliance.with_agenda_published': { label: 'With Agenda Published', type: 'number' },
        'meeting_compliance.with_public_notice': { label: 'With Public Notice', type: 'number' },
    },
    dimensions: {
        // Meeting Body
        'meeting_bodies.is_active': { label: 'Meeting Body Is Active', type: 'boolean' },
        'meeting_bodies.meeting_frequency': { label: 'Meeting Frequency', type: 'string' },
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        'meeting_bodies.type': {
            label: 'Meeting Body Type',
            type: 'string',
            valueLabels: meetingBodyTypeValueLabels,
        },
        // Meeting
        'meetings.agenda_item_count': { label: 'Agenda Item Count', type: 'number' },
        'meetings.duration_minutes': { label: 'Duration (Minutes)', type: 'number' },
        'meetings.is_cancelled': { label: 'Is Cancelled', type: 'boolean' },
        'meetings.status': {
            label: 'Meeting Status',
            type: 'string',
            valueLabels: meetingStatusValueLabels,
        },
        'meetings.title': { label: 'Meeting Title', link: meetingLink, type: 'string' },
        // Compliance
        'meeting_compliance.has_agenda_published': {
            label: 'Has Agenda Published',
            type: 'boolean',
        },
        'meeting_compliance.has_public_notice': { label: 'Has Public Notice', type: 'boolean' },
    },
    timeDimensions: {
        'meeting_compliance.notice_posted_at': { label: 'Notice Posted At', type: 'date' },
        'meetings.agenda_published_at': { label: 'Agenda Published At', type: 'date' },
        'meetings.date': { label: 'Meeting Date', type: 'date' },
    },
};
